export const primaryFilterOptions = ['Region', 'Market', 'Retailer', 'Category', 'Brand', 'SubCategory'];
export const filterOptionsWithoutSubcateg = ['Region', 'Market', 'Retailer', 'Category', 'Brand'];
export const limitedFilterOptions = ['Region', 'Market'];
